import produce from "immer";

const defaultState = {
    authenticated: false,
    error: false,
    errorMessage: null,
    errorStack: null
}

export default function(state = defaultState, action) {
    switch (action.type) {
        case 'AUTH_SUCCESSFUL':
            return {
                ...state,
                authenticated: true,
                error: false,
                errorMessage: null,
                errorStack: null
            };
        case 'TOKEN_INVALID': {
            return produce(state, draft => {
                draft.authenticated = false;
                if(action.error) {
                    draft.error = true;
                    draft.errorMessage = action.error.toString();
                    draft.errorStack = action.error.stack;
                }
            });
        }
        case 'AUTH_ERROR': {
            return produce(state, draft => {
                draft.authenticated = false;
                if(action.error) {
                    draft.error = true;
                    draft.errorMessage = action.error.toString();
                    draft.errorStack = action.error.stack;
                }
            });
        }
        case 'LOGIN': {
            return defaultState;
        }
        default:
            return state
    }
}